import { render, staticRenderFns } from "./TeamsDetails.vue?vue&type=template&id=d00f0de4&scoped=true"
import script from "./TeamsDetails.vue?vue&type=script&lang=js"
export * from "./TeamsDetails.vue?vue&type=script&lang=js"
import style0 from "./TeamsDetails.vue?vue&type=style&index=0&id=d00f0de4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f0de4",
  null
  
)

export default component.exports